import React, { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { TableDensityProvider } from '../context/TableDensityContext';
import { ProjectProvider } from '../context/ProjectContext';
import { UserProvider } from '../context/UserContext';

export default function AppLayout({ children }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <TableDensityProvider>
      <ProjectProvider>
        <UserProvider>
          <Box minH="100vh" bg="gray.50" overflowX="hidden" pt="64px">
            <Header onOpenMenu={() => setIsMobileMenuOpen(true)} />
            <Flex minH="calc(100vh - 64px)" overflow="hidden">
              <Sidebar
                isMobileMenuOpen={isMobileMenuOpen}
                onCloseMobileMenu={() => setIsMobileMenuOpen(false)}
                collapsed={sidebarCollapsed}
                setCollapsed={setSidebarCollapsed}
              />
              <Box 
                as="main" 
                flex={1} 
                p={{ base: 3, md: 6 }} 
                overflowX="auto" 
                minW={0}
                ml={{ base: 0, md: sidebarCollapsed ? "72px" : "220px" }}
                transition="margin-left 0.2s"
              >
                {children}
              </Box>
            </Flex>
          </Box>
        </UserProvider>
      </ProjectProvider>
    </TableDensityProvider>
  );
}